import { HostAPIBase } from './HostAPIBase';
import { PLATFORM_BREAKPOINT_RANGES } from '@wix/editor-platform-host-integration-apis';
export class HostAPIEditorX extends HostAPIBase {
    constructor() {
        super(...arguments);
        this.breakpoints = {
            get: (compRef) => {
                return this.platformApiMethods.editor.breakpoints.get(compRef);
            },
        };
        this.stage = {
            getPointerWithCurrentVariants: (editorPointer) => {
                return this.platformApiMethods.editor.stage?.getPointerWithCurrentVariants(editorPointer);
            },
            getBreakpointFromPointer: (editorPointer) => {
                return this.platformApiMethods.editor.stage?.getBreakpointFromPointer(editorPointer, PLATFORM_BREAKPOINT_RANGES);
            },
        };
    }
}
//# sourceMappingURL=HostAPIEditorX.js.map